<template>
	<v-card>
		<v-card-title class="mt-3">
			<h1>Monitoring</h1>
		</v-card-title>
		<v-card-text v-if="hasForm">
			<v-container fluid>
				<div v-if="monitoringReports.length > 0">
					<v-layout mb-3 align-center>
						<h3>Lista raportów z monitoringu</h3>
						<v-btn @click="createMonitoringReport"
							v-if="monitoringReports[monitoringReports.length -1].status === 'FINISHED'" class="success"
							style="float: left">Dodaj raport
						</v-btn>
					</v-layout>
					<v-layout v-for="monitoring in monitoringReports" v-bind:key="monitoring.id">
						<div>
							<span v-if="monitoring.status === 'FINISHED'">
								Zakończony {{monitoring.finishDate}} przez użytkownika {{monitoring.finisher}}
							</span>
							<span v-if="monitoring.status === 'STARTED'">
								Rozpoczęty {{monitoring.creationDate}} przez użytkownika {{monitoring.creator}}
							</span>
							<v-tooltip bottom>
								<template v-slot:activator="{ on }">
									<v-btn icon
										:disabled="!canEditMonitoring(monitoring)"
										@click="navigateToMonitoring(monitoring.id)">
										<v-icon v-on="on">
											edit
										</v-icon>
									</v-btn>
								</template>
								<span>Edycja</span>
							</v-tooltip>
							<v-tooltip bottom>
								<template v-slot:activator="{ on }">
									<v-btn icon
										@click="navigateToMonitoringView(monitoring.id)">
										<v-icon v-on="on">
											description
										</v-icon>
									</v-btn>
								</template>
								<span>Podgląd</span>
							</v-tooltip>
							<v-tooltip bottom v-if="canDeleteMonitoring(monitoring)">
								<template v-slot:activator="{ on }">
									<v-btn icon
										@click="deleteMonitoring(monitoring.id)">
										<v-icon v-on="on" color="lightred">
											delete
										</v-icon>
									</v-btn>
								</template>
								<span>Usuń</span>
							</v-tooltip>
						</div>
					</v-layout>
				</div>
				<v-layout v-else align-center fill-height>
					<h3>Monitoring projektu nie został jeszcze przeprowadzony</h3>
					<v-btn @click="createMonitoringReport" class="success">Dodaj raport</v-btn>
				</v-layout>

			</v-container>
		</v-card-text>
		<v-card-text v-else>
			<h3 class="ml-4 mt-4">Formularz raportu z monitoringu powinien być zdefiniowany.</h3>
		</v-card-text>
		<v-container fluid>
		<v-layout><h3>Uwagi</h3></v-layout>
			<v-layout>
				<v-flex>
					<v-textarea outline auto-grow v-model="project.monitoringRemarks"
						browser-autocomplete="off" aria-label="monitoring remarks"></v-textarea>
				</v-flex>
			</v-layout>
			<v-btn primary @click="saveProjectMonitoringRemarks">Zapisz</v-btn>
		</v-container>
	</v-card>
</template>

<script>
	import {Monitoring} from "../../../api/generated/Monitoring";
	import {Project} from "../../../api/generated/Project";

	export default {
		name: "ProjectMonitoringList",
		data() {
			return {
				projectStatus: null,
				monitoringReports: [],
				editedItem: {},
				hasForm: false,
				projectId: this.$route.params.projectId
			};
		},

		created() {
			this.loadData();
		},

		methods: {
			loadData() {
				Monitoring.getConfiguration(this, this.$route.params.projectId, successReponse => {
					this.hasForm = successReponse !== null && successReponse.schema !== '' && successReponse.schema !== null;
				});
				Monitoring.getList(this, this.$route.params.projectId, successResponse => {
				this.monitoringReports = successResponse.sort((a, b) => {
					const dateA = a.status === 'FINISHED' ? new Date(a.finishDate) : new Date(a.creationDate);
					const dateB = b.status === 'FINISHED' ? new Date(b.finishDate) : new Date(b.creationDate);

					return dateA - dateB; 
				});
			});
				Project.getStatus(this, this.$route.params.projectId, successResponse => {
						this.projectStatus = successResponse.projectStatus;
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się załadować statusu konkursu", errorResponse);
					});
			},

			createMonitoringReport() {
				if (!this.projectStatus || this.projectStatus === 'WITHDRAWN') {
					this.$messagesBus.$emit("error", "Nieodpowiedni status konkursu");
					return;
				}
				Monitoring.post(this, this.$route.params.projectId, success => {
					this.navigateToMonitoring(success);
				});
			},
			navigateToMonitoring(monitoringId) {
				this.$router.push("/app/" + this.$route.params.contestId + "/" + this.$route.params.projectId + "/monitoring-form/" + monitoringId);
			},

			navigateToMonitoringView(monitoringId) {
				this.$router.openInNewTab("/view/project/" + this.projectId + "/monitoring-form/" + monitoringId);
			},

			deleteMonitoring(monitoringId) {
				this.$confirm("Czy na pewno chcesz usunąć monitoring?", {
					icon: 'delete',
					title: 'Usuwanie monitoringu',
					color: "primary",
					width: 500
				})
					.then(response => {
						if (response) {
							Monitoring.delete(this, monitoringId,
								() => {
									this.loadData();
									this.$messagesBus.$emit("success", "Pomyślnie usunięto raport z monitoringu");
								},
								() => {
									this.$messagesBus.$emit("error", "Nie udało się usunąć raportu z monitoringu");
								});
						}
					});
			},
			canEditMonitoring(monitoring) {
				return (monitoring.status === 'STARTED' || (monitoring.status === 'FINISHED' && this.hasProjectPanelAdminModificationAccess()));
			},
			canDeleteMonitoring(monitoring){
				return (monitoring.status === 'FINISHED' && this.hasProjectPanelAdminModificationAccess());
			},
			hasProjectPanelAdminModificationAccess(){
				return this.$store.state.projectPanelPermissions.hasProjectPanelAdminModificationAccess;
			},
			saveProjectMonitoringRemarks() {
				Project.putMonitoringRemarks(this, this.$route.params.projectId, {body: this.project.monitoringRemarks});
			},
		},
		props: {
			project: {
				type: Object
			},
		},
	};
</script>

<style scoped>

</style>
